import { useEffect, useState } from "react";

const useModal = (status) => {
  const [open, setOpen] = useState(status);
 
  useEffect(() => {
    setOpen(false)
  }, [])

  function toggle() {
    setOpen(!open);
  }

  return { open, toggle };

};

export default useModal;
